module.exports = __webpack_public_path__ + "static/media/chaturbate.b794fe7c.mp3";